import React from 'react';
import { Button, Card } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import './TeamCard.css'

const TeamCard = (props) => {

    const {strTeam,idTeam,strTeamBadge} =props.team;

    
    return (
        
        
            <div className="col-md-4 mb-3">
            <Card className='card-style' style={{ width: '20rem' }}>
                <Card.Img className='topImageCard' fluid="md" variant="top" src={strTeamBadge} />
                <Card.Body>
                    <Card.Title>{strTeam}</Card.Title>
                    <Card.Text>
                        Sports Type : Football
                    </Card.Text>
                    <Button variant="primary">
                      <Link style={{color:'#fff'}} to={`/team/${idTeam}`}>Explore</Link>  
                    </Button>
                </Card.Body>
            </Card>
            </div>
        
    );
};

export default TeamCard;